var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table",class:{'is-inline': _vm.isInline}},[(_vm.empty)?_c('div',{staticClass:"table-empty"},[_vm._v(" "+_vm._s(_vm.emptyMessage)+" ")]):_vm._e(),(!_vm.empty)?[_vm._t("default")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }